module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-down-0270d08906306dbec84b344e473f9686.svg";